export const LANDING = '/home';
export const HOME = '/home';
export const SEARCH = '/search';
export const LIBRARY = '/library';
export const PLAYLIST = '/playlist';